import React, { ExoticComponent, Fragment, ReactNode } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Form as BootstrapForm } from 'react-bootstrap';
import { Form, FormikErrors } from 'formik';
import { FormattedMessage } from 'react-intl';
import Alert from 'react-bootstrap/Alert';
import { TextField } from '../components/fields';
import SubmitButton from '../components/submit-button';
import ErrorMessage from '../components/error-message';
import { AddNewDealName } from '../consts/forms-constants';
import { FolderTreeSelector } from '../components/folder-tree-selector';

interface AddNewDealFormProps {
  bodyContainer: ExoticComponent<{ children?: ReactNode }>;
  actionsContainer: ExoticComponent<{ children?: ReactNode }>;
  renderSecondaryAction: any;
  errors: FormikErrors<any>;
  values: { [key: string]: string };
  isSubmitting: boolean;
  isValid: boolean;
  folders: any[];
  setFieldValue: (field: string, value: any) => void;
}

const AddNewDealForm = ({
  bodyContainer: BodyContainer = Fragment,
  actionsContainer: ActionsContainer = Fragment,
  renderSecondaryAction,
  errors,
  isSubmitting,
  isValid,
  folders,
  values,
  setFieldValue,
}: AddNewDealFormProps) => {
  return (
    <Form noValidate>
      <BodyContainer>
        {errors._general && (
          <Alert variant="danger">
            <ErrorMessage>{errors._general}</ErrorMessage>
          </Alert>
        )}

        <Row>
          <Col lg={12}>
            <TextField
              id="addNewDeal.name"
              name="deal_name"
              type="deal_name"
              label={<FormattedMessage id={AddNewDealName.id} defaultMessage={AddNewDealName.defaultMessage} />}
            />
            <div>
              <strong>Tip:</strong> Choose a good name, as the counterparty will also see it.
            </div>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col lg={12}>
            <BootstrapForm.Group className="w-100">
              <BootstrapForm.Label>
                <FormattedMessage id="deals.folder.label" defaultMessage="Deal Folder" />
              </BootstrapForm.Label>
              <FolderTreeSelector
                folders={folders}
                selectedFolderId={values.folder_id}
                onSelectionChange={(folderId) => setFieldValue('folder_id', folderId)}
                disabled={isSubmitting}
                context="deals"
              />
              <div className="form-text mt-2">
                <FormattedMessage
                  id="deals.upload.folder-help"
                  defaultMessage="Choose the folder where this deal will be created. Select 'All Deals (Root)' to create it at the top level."
                />
              </div>
            </BootstrapForm.Group>
          </Col>
        </Row>
      </BodyContainer>

      <ActionsContainer>
        {renderSecondaryAction && renderSecondaryAction()}
        <SubmitButton
          label={<FormattedMessage id="id.create-deal" defaultMessage="Create Deal" />}
          disabled={isSubmitting || !isValid}
          isSubmitting={isSubmitting}
        />
      </ActionsContainer>
    </Form>
  );
};

export default AddNewDealForm;
